export interface MouduleGroup {
    id: string;
    name: string;
}

export interface QRScanPageInfo {
    success_message: string;
    redirect_home_message: string;
    redirect_home_link_text: string;
    download_message: string;
    android_link: boolean;
    apple_link: boolean;
    logout_message: string;
    cancelled_logout_message: string;
}

export interface EntityAccount {
    account_id: string,
    name: string,
    structures: string[],
    timestamp: Date,
    web_idle_session_timeout_seconds?: number,
    structure_id?: string,
    scheduling?: object,
    schedulingRoutes?: object,
    tasking?: object,
    annotation?: object,
    adminTool?: object,
    qrScanPage?: QRScanPageInfo,
    moduleGroups?: MouduleGroup[]
}

export class Account {
    static create (userData: EntityAccount): Account {
        const {
            account_id: accountId,
            name,
            structures,
            timestamp: timestampString,
            web_idle_session_timeout_seconds: webIdleSessionTimeoutSecondsRaw,
            scheduling,
            schedulingRoutes,
            tasking,
            annotation,
            adminTool,
            qrScanPage,
            moduleGroups
        } = userData;
        
        const timestamp = new Date(timestampString);
        const webIdleSessionTimeoutSeconds = webIdleSessionTimeoutSecondsRaw ? webIdleSessionTimeoutSecondsRaw : -1;
        return new Account(
            accountId,
            name,
            structures ? structures : [userData.structure_id ? userData.structure_id : ''],
            timestamp,
            webIdleSessionTimeoutSeconds,
            scheduling,
            schedulingRoutes,
            tasking,
            annotation,
            adminTool,
            qrScanPage,
            moduleGroups
        );
    }

    constructor (
        public readonly accountId: string,
        public readonly name: string,
        public readonly structures: string[],
        public readonly timestamp: Date,
        public readonly webIdleSessionTimeoutSeconds: number,
        public readonly scheduling?: object,
        public readonly schedulingRoutes?: object,
        public readonly tasking?: object,
        public readonly annotation?: object,
        public readonly adminTool?: object,
        public readonly qrScanPage?: QRScanPageInfo,
        public readonly moduleGroups?: MouduleGroup[]
    ) {
    }
}
